<template>
    <div class="service-page" @scroll="bingsrcoll">
        <!-- pc 端 -->
        <div class="hidden-sm-and-down"  style="height:100%;">
                <div class="first-page">
                    <img v-if="ServiceSupportData.children[0].requestType.indexOf('image')>-1" :src="ServiceSupportData.children[0].requestPath" :alt="ServiceSupportData.dictLabel" style="height:100%;">
                    <div v-else style="width: 100%;height:100%;">
                        <video class="header-video" id="aboutvideo" width="100%" height="100%" name="media" muted loop>
                            <source  :src="ServiceSupportData.children[0].requestPath" type="video/mp4">
                            <span v-if = "this.isEn != '1'">您的浏览器不支持 video 标签。</span>
                            <span v-if = "this.isEn == '1'">The browser does not support video tags.</span>
                        </video>
                    </div>
                    <div class="first-page-titlepart">
                        <div class="first-page-title">{{ServiceSupportData.children[0].title}}</div>
                        <div class="first-page-titlebottom"></div>
                        <div  v-if="videoAll&&videoAll[0]&&videoAll[0].title=='观看全部视频'" @click="openVideoShow" style="text-align: left;font-size: 22px;cursor: pointer;">
                            <i class="el-icon-video-play" style="font-weight: inherit;font-size: 30px;vertical-align: text-top;margin-right: 2px;"></i>
                            观看全部视频
                        </div>
                        <pre v-else class="first-page-titledesc">{{ServiceSupportData.children[0].content}}</pre>

                    </div>
                </div>

            <div :class="['about-menu', window_height<(scroll_Value+10)?'fix-menu':'']">
                <div @click.prevent="custormAnchor('miao1')" href="#miao1" >
                    <span v-if="this.isEn == '0'" :class="[custormAnchor_nav=='miao1'?'menu-active':'']">售后服务</span>
                    <span v-else-if="this.isEn == '1'" :class="[custormAnchor_nav=='miao1'?'menu-active':'']">Customer service</span>
                </div>
                <div @click.prevent="custormAnchor('miao2')" href="#miao2">
                    <span v-if="this.isEn == '0'" :class="[custormAnchor_nav=='miao2'?'menu-active':'']">常见问题</span>
                    <span v-if="this.isEn == '1'" :class="[custormAnchor_nav=='miao2'?'menu-active':'']">Frequently Asked Question</span>
                </div>
                <!-- <div @click.prevent="custormAnchor('miao3')" href="#miao3">
                    <span :class="[custormAnchor_nav=='miao3'?'menu-active':'']">资料下载</span>
                </div> -->
                 <div @click.prevent="custormAnchor('miao4')" href="#miao4">
                    <span v-if="this.isEn == '0'" :class="[custormAnchor_nav=='miao4'?'menu-active':'']">联系我们</span>
                    <span v-if="this.isEn == '1'" :class="[custormAnchor_nav=='miao4'?'menu-active':'']">Contact us</span>
                </div>
            </div>
            <div class="about-content row">
                <div id="miao1" :class="['row','col-md-90',custormAnchor_nav=='miao1'?'show-mao':'hide-mao']" style="padding-left: 0;">
                    <div class="col-md-4" style="padding-left: 0;">
                    <div class="about-content-title">
                        <div v-if="this.isEn == '0'">售后服务</div>
                        <div  v-if="this.isEn == '1'">Customer service</div>
                        <!-- <div class="about-content-secondtitle">INTRODUCTION</div> -->
                    </div>
                    </div>
                    <div class="col-md-8">
                    <div class="change-p">
                        <pre class="afterService-content">{{CompanyData.companyInfo.afterService}}</pre>
                        <!-- <div>
                            <p>本公司所有售出的机具设备均享受以下售后服务：</p>
                            <p>一、 提供的读写器产品实行12个月内保修，3个月内保换。</p>
                            <p>二、 本公司对所有售出的产品实行终身维护。对于保修保换的产品，甲方须将该产品发回我司指定的维修地点，待查验无误后，进行保修保换。</p>
                            <p>三、 对于客户自行拆装过的产品或因人为原因造成产品损坏，如需修换，则需支付相应的修换费用。卡座以及人为损坏情况需酌情收费。</p>
                            <p style="margin-bottom:20px !important;">四、 提供专用的售后服务热线和电子邮箱地址，对甲方在开发过程中的任何疑难问题进行技术支持。</p>

                            <p>服务热线：400-888-7816 </p>
                            <p>售前咨询分机 316 </p>
                            <p>开发支持分机 333/338</p>
                            <p style="margin-bottom:20px !important;">服务邮箱：info@decard.com</p>

                            <p>公司总机：0755-86675660/61/62/63</p>
                            <p>公司传真：0755-26629399</p>
                        </div> -->
                    </div>
                    <div class="applet-qrcode" style="width: 100%;margin-top: 50px;">
                        <img src="../assets/img/applet.jpg" alt="" class="applet-img" />
                        <div class="applet-text">
                            <div v-if="isEn == '0'">
                                <div>产品维保</div>
                                <div>请扫码进行售后服务</div>
                            </div>
                            <div v-else>
                                <div>Please scan the code</div>
                            </div>
                            
                        </div>
                    </div>
                    </div>
                    <div class="col-md-12 row middle2" style="padding:0px;margin-top:50px;">
                    <div class="zidingyi-col4 " v-for="(item,index) in companyProfileData.children" :key="index">
                        <img :src="item.requestPath" :alt="item.title" style="width:100%;" />
                    </div>

                    </div>
                </div>
                <div id="miao2" :class="['row','col-md-90',custormAnchor_nav=='miao2'?'show-mao':'hide-mao']">
                    <div class="col-md-4">
                    <div class="about-content-title">
                        <div v-if="this.isEn == '0'">常见问题</div>
                        <div v-if="this.isEn == '1'">Frequently Asked Question</div>
                        <!-- <div class="about-content-secondtitle">INTRODUCTION</div> -->
                    </div>
                    </div>
                    <div class="col-md-8">
                        <div id="steps1">
                            <el-collapse v-for="(item,index) in this.commonProblemList" :key="index" class="changIcon">
                                <el-collapse-item>
                                    <template slot="title">
                                        <div class="quest-title">
                                            {{item.title}}
                                        </div>
                                        <!-- <p :class="[activeNames.toString().indexOf('a1')>-1?'el-icon-remove-outline':'el-icon-circle-plus-outline']"></p> -->
                                    </template>
                                    <div class="quest-describe" style="display: block;">
                                      <mdPreview :newsDetailData="item.problemDetails" :imageClick="imageClick" style="height: 100%"></mdPreview>
                                    </div>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                    </div>
                </div>
                <div id="miao3" :class="['row','col-md-90',custormAnchor_nav=='miao3'?'show-mao':'hide-mao']">
                    <div class="row col-md-12 about-content-title">
                        <div class="col-md-5">
                            资料下载
                        </div>
                        <div class="col-md-7 radius-input" style="text-align: right;">
                            <el-input v-model="SearchInformation" placeholder="请输入搜索内容"></el-input>
                        </div>
                    </div>
                    <div class="col-md-12 Information-content">
                        <div class="col-md-6 Information-list" v-for="(item,index) in currentlist" :key="index">
                            <span> {{item.label}} </span>
                            <span style="float:right;margin-right:0px;" class="downloadSpan">
                                <a :href="item.path" :download="item.path"   style="text-decoration: none;font-size:14px;">
                                    <span class="el-icon-download" style="font-size: 16px;margin-right: -2px;">
                                    </span>
                                    下载
                                </a>
                            </span>
                        </div>
                    </div>
                    <div class="page-contont">
                        <div>共{{InformationList.length}}条</div>
                        <div>
                            <span :class="['el-icon-arrow-left',currentPage==1?'cant-page':'']" @click="gopage(currentPage-1)"></span>
                            <span @click="gopage(currentPage)">{{currentPage}}</span>
                            <span :class="['el-icon-arrow-right',currentPage+1>Math.ceil(this.InformationList.length/20)?'cant-page':'']" @click="gopage(currentPage+1)"></span>
                        </div>
                        <div>
                            前往
                            <div class="el-input el-pagination__editor is-in-pagination" style="width:auto;text-align: center;">
                                <!-- <el-input v-model="currentPage" type="text" min="1" max="4" οnKeyUp="value=value.replace(/\D/g,'')" @change="gojump"></el-input> -->
                                <el-input
                                    v-model="currentPage"
                                    maxlength="2"
                                    class="addPriceRowRightInput"
                                ></el-input>
                                    <!-- onKeyUp="value=value.replace(/[\W]/g,'1')" -->
                            </div>
                            页
                        </div>

                    </div>
                </div>
                <div id="miao4" :class="['row','col-md-90',custormAnchor_nav=='miao4'?'show-mao':'hide-mao']">
                    <div class="miao4-title"  v-if="this.isEn == '0'" >联系我们</div>
                    <div class="miao4-title"  v-if="this.isEn == '1'" >Contact us</div>
                    <div class="miao4-content" style="width:100%">
                        <div class="contact-way clearfix" v-if="this.isEn == '0'">
                            <div class="zidingyi-col4" v-for="item in CompanyData.companyParamList" style="padding-right:15px;">
                                <img :src="item.picUrl" :alt="item.branchCompanyName" style="width: 100%;height:188px;">
                                <div  class="contact-way-rowdiv">
                                    <div class="contact-title">{{item.branchCompanyName}}</div>
                                    <div v-if="item.telphone">电话 : {{item.telphone}}</div>
                                    <div v-if="item.fax">传真 : {{item.fax}}</div>
                                    <div v-if="item.saleTelphone">售前咨询 : {{item.saleTelphone}}</div>
                                    <div v-if="item.address">地址 : {{item.address}}</div>
                                </div>
                            </div>
                            <!-- <div class="zidingyi-col4" >
                                <img src="../assets/img/home22_img.jpg" alt="深圳总部" style="width: 100%;">
                                <div  class="contact-way-rowdiv">
                                    <div class="contact-title">深圳总部</div>
                                    <div>总机 : 0755-86675660/61/62/63</div>
                                    <div>传真 : 0755-26629399</div>
                                    <div>售前咨询 : 0755-86675660/61/62/63转316</div>
                                    <div>地址 : 深圳市南山区茶光路文光工业区17栋四楼</div>
                                </div>
                            </div>
                            <div class="zidingyi-col4" style="margin:0 2%;">
                                <div style="text-align: center;">
                                    <img src="../assets/img/home23_img.jpg" alt="北京公司" style="width: 100%;">
                                    <div  class="contact-way-rowdiv">
                                        <div class="contact-title">北京公司</div>
                                        <div>电话 : 010-59693060 </div>
                                        <div>地址 : 北京市朝阳区百子湾西里402金海商富中心A座1311室</div>
                                    </div>
                                </div>
                            </div>
                            <div class="zidingyi-col4" style="text-align: right;">
                                <img src="../assets/img/home24_img.jpg" alt="西安研发中心" style="width: 100%;">
                                <div class="contact-way-rowdiv">
                                    <div class="contact-title">西安研发中心</div>
                                    <div>电话 : 029-68201628 </div>
                                    <div>传真 : 029-68201691</div>
                                    <div>地址 : 西安市雁塔区沣惠南路16号泰华金贸国际8号楼7层</div>
                                </div>
                            </div> -->
                        </div>
                      <div class="contact-way clearfix" v-if="this.isEn == '1'">
                        <div class="zidingyi-col4" v-for="item in CompanyData.companyParamList" style="padding-right:15px;">
                          <img :src="item.picUrl" :alt="item.branchCompanyName" style="width: 100%;height:188px;">
                          <div  class="contact-way-rowdiv">
                            <div class="contact-title">{{item.branchCompanyName}}</div>
                            <div v-if="item.telphone">Telephone : {{item.telphone}}</div>
                            <div v-if="item.fax">Fax number : {{item.fax}}</div>
                            <div v-if="item.saleTelphone">Pre-consultation : {{item.saleTelphone}}</div>
                            <div v-if="item.email">E-mail : {{ item.email }}</div>
                            <div v-if="item.whatsApp">WhatsApp : {{ item.whatsApp }}</div>
                            <div v-if="item.address">Address : {{item.address}}</div>
                          </div>
                        </div>
                        <!-- <div class="zidingyi-col4" >
                            <img src="../assets/img/home22_img.jpg" alt="深圳总部" style="width: 100%;">
                            <div  class="contact-way-rowdiv">
                                <div class="contact-title">深圳总部</div>
                                <div>总机 : 0755-86675660/61/62/63</div>
                                <div>传真 : 0755-26629399</div>
                                <div>售前咨询 : 0755-86675660/61/62/63转316</div>
                                <div>地址 : 深圳市南山区茶光路文光工业区17栋四楼</div>
                            </div>
                        </div>
                        <div class="zidingyi-col4" style="margin:0 2%;">
                            <div style="text-align: center;">
                                <img src="../assets/img/home23_img.jpg" alt="北京公司" style="width: 100%;">
                                <div  class="contact-way-rowdiv">
                                    <div class="contact-title">北京公司</div>
                                    <div>电话 : 010-59693060 </div>
                                    <div>地址 : 北京市朝阳区百子湾西里402金海商富中心A座1311室</div>
                                </div>
                            </div>
                        </div>
                        <div class="zidingyi-col4" style="text-align: right;">
                            <img src="../assets/img/home24_img.jpg" alt="西安研发中心" style="width: 100%;">
                            <div class="contact-way-rowdiv">
                                <div class="contact-title">西安研发中心</div>
                                <div>电话 : 029-68201628 </div>
                                <div>传真 : 029-68201691</div>
                                <div>地址 : 西安市雁塔区沣惠南路16号泰华金贸国际8号楼7层</div>
                            </div>
                        </div> -->
                      </div>
                        <div class="miao4-content-list clearfix" v-show="MarketCenterInfoList_data.length>0 && isShowAgentList && this.isEn == '0'">
                            <div class="miao4-content-list-title">各地营销中心</div>
                            <div class="miao4-content-item-box">
                                <div class="miao4-content-list-item" v-for="item in MarketCenterInfoList_data" :key="item.agentCode">
                                    <div class="miao4-content-list-item-title">{{item.agentAbbr | blankFormat}}</div>
                                    <div class="miao4-content-list-item-row clearfix">
                                        <div class="miao4-content-list-item-left">联系：</div>
                                        <div class="miao4-content-list-item-right">{{(item.userName) | blankFormat}}</div>
                                    </div>
                                    <div class="miao4-content-list-item-row clearfix">
                                        <div class="miao4-content-list-item-left">电话： </div>
                                        <div class="miao4-content-list-item-right">{{(item.mobile ) | blankFormat}}</div>
                                    </div>
                                    <div class="miao4-content-list-item-row clearfix" v-if="item.landline">
                                        <div class="miao4-content-list-item-left">座机： </div>
                                        <div class="miao4-content-list-item-right">{{item.landline}}</div>
                                    </div>
                                    <div class="miao4-content-list-item-row clearfix">
                                        <div class="miao4-content-list-item-left">邮箱： </div>
                                        <div class="miao4-content-list-item-right">{{(item.emailAccount) | blankFormat}}</div>
                                    </div>
                                    <div class="miao4-content-list-item-row clearfix">
                                        <div class="miao4-content-list-item-left">地址： </div>
                                        <div class="miao4-content-list-item-right">{{item.address | blankFormat}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        <videoCommon ref="videoProp" v-if="videoAll[0]" :videoTitle="videoAll[0].title" :videoUrl="videoAll[0].requestPath"></videoCommon>
        <home-foot></home-foot>
        </div>
        <!-- 移动端 -->
        <div class="visible-sm-and-down" >
            <div class="mobile-banner">
                <img src="../assets/mobile/servicesupport01_img.png" alt="服务支持">
                <!-- <div class="mobile-banner-title">
                    <div>服务支持</div>
                    <div>SERVICE SUPPORT</div>
                </div> -->
            </div>
            <div class="mobile-content">
                <div class="mobile-content-title">
                    <div>售后服务</div>
                </div>
                <div class="mobile-change-p">
                    <pre class="afterService-content">{{CompanyData.companyInfo.afterService}}</pre>
                    <!-- <div style="margin-top:20px;font-size:14px;">
                        <p>本公司所有售出的机具设备均享受以下售后服务：</p>
                        <p>一、 提供的读写器产品实行12个月内保修，3个月内保换。</p>
                        <p>二、 本公司对所有售出的产品实行终身维护。对于保修保换的产品，甲方须将该产品发回我司指定的维修地点，待查验无误后，进行保修保换。</p>
                        <p>三、 对于客户自行拆装过的产品或因人为原因造成产品损坏，如需修换，则需支付相应的修换费用。卡座以及人为损坏情况需酌情收费。</p>
                        <p style="margin-bottom:20px !important;">四、 提供专用的售后服务热线和电子邮箱地址，对甲方在开发过程中的任何疑难问题进行技术支持。</p>

                        <p>服务热线：400-888-7816 </p>
                        <p>售前咨询分机 316 </p>
                        <p>开发支持分机 333/338</p>
                        <p>服务邮箱：info@decard.com</p>
                        <p>公司总机：0755-86675660/61/62/63</p>
                        <p>公司传真：0755-26629399</p>
                    </div> -->
                </div>
                <div class="applet-qrcode" style="text-align: center;">
                        <img src="../assets/img/applet.jpg" alt="" class="applet-img" style="width: 128px;"/>
                        <div class="applet-text" style="width:100%">
                            <div v-if="isEn == '0'">
                                <div>产品维保</div>
                                <div>请扫码进行售后服务</div>
                            </div>
                            <div v-else>
                                <div style="width: 128px;text-align: center;">Please scan the code</div>
                            </div>
                        </div>
                </div>
                <img v-for="(item,index) in companyProfileData.children" :key="index" :src="item.requestPath" :alt="item.title" style="width:100%;" />
                <!-- <img src="../assets/img/Service3_img.jpg" alt="服务支持"> -->
                <div class="visible-sm-and-down" style="font-size: 14px;overflow: hidden;line-height: 24px;margin-top:50px;">
                    <div style="font-weight:600;float: left;font-size: 22px;">联系我们</div>
                    <div style="float: right;color: #00ACF5;font-weight: normal;" >服务热线 : {{CompanyData.companyInfo.hotline || phoneNum}}</div>
                </div>
                <div class="contact-way clearfix" >
                    <div class="col-md-4" v-for="item in CompanyData.companyParamList">
                        <img :src="item.picUrl" :alt="item.branchCompanyName" style="width: 100%;height:188px;">
                        <div  class="contact-way-rowdiv">
                            <div class="contact-title">{{item.branchCompanyName}}</div>
                            <div v-if="item.telphone">电话 : {{item.telphone}}</div>
                            <div v-if="item.fax">传真 : {{item.fax}}</div>
                            <div v-if="item.saleTelphone">售前咨询 : {{item.saleTelphone}}</div>
                            <div v-if="item.address">地址 : {{item.address}}</div>
                        </div>
                    </div>
                    <!-- <div class="md-col4" >
                        <img src="../assets/img/home22_img.jpg" alt="深圳总部" style="width: 100%;">
                        <div  class="contact-way-rowdiv">
                            <div class="contact-title">深圳总部</div>
                            <div>总机 : 0755-86675660/61/62/63</div>
                            <div>传真 : 0755-26629399</div>
                            <div>售前咨询 : 0755-86675660/61/62/63转316</div>
                            <div>地址 : 深圳市南山区茶光路文光工业区17栋四楼</div>
                        </div>
                    </div>
                    <div class="md-col4">
                        <div style="text-align: center;">
                            <img src="../assets/img/home23_img.jpg" alt="北京公司" style="width: 100%;">
                            <div  class="contact-way-rowdiv">
                                <div class="contact-title">北京公司</div>
                                <div>电话 : 010-59693060 </div>
                                <div>地址 : 北京市朝阳区百子湾西里402金海商富中心A座1311室</div>
                            </div>
                        </div>
                    </div>
                    <div class="md-col4" style="text-align: right;">
                        <img src="../assets/img/home24_img.jpg" alt="西安研发中心" style="width: 100%;">
                        <div class="contact-way-rowdiv">
                            <div class="contact-title">西安研发中心</div>
                            <div>电话 : 029-68201628 </div>
                            <div>传真 : 029-68201691</div>
                            <div>地址 : 西安市雁塔区沣惠南路16号泰华金贸国际8号楼7层</div>
                        </div>
                    </div> -->
                </div>
                <div class="miao4-content-list clearfix" v-show="MarketCenterInfoList_data.length>0  && isShowAgentList">
                    <div class="miao4-content-list-title">各地营销中心</div>
                    <div class="miao4-content-list-item" v-for="item in MarketCenterInfoList_data" :key="item.agentCode">
                        <div class="miao4-content-list-item-title">{{item.agentAbbr | blankFormat}}</div>
                        <div class="miao4-content-list-item-row clearfix">
                            <div class="miao4-content-list-item-left">联系：</div>
                            <div class="miao4-content-list-item-right">{{(item.userName) | blankFormat}}</div>
                        </div>
                        <div class="miao4-content-list-item-row clearfix">
                            <div class="miao4-content-list-item-left">电话： </div>
                            <div class="miao4-content-list-item-right">{{(item.mobile) | blankFormat}}</div>
                        </div>
                        <div class="miao4-content-list-item-row clearfix" v-if="item.landline">
                            <div class="miao4-content-list-item-left">座机： </div>
                            <div class="miao4-content-list-item-right">{{item.landline}}</div>
                        </div>
                        <div class="miao4-content-list-item-row clearfix">
                            <div class="miao4-content-list-item-left">邮箱： </div>
                            <div class="miao4-content-list-item-right">{{(item.emailAccount) | blankFormat}}</div>
                        </div>
                            <div class="miao4-content-list-item-row clearfix">
                            <div class="miao4-content-list-item-left">地址： </div>
                            <div class="miao4-content-list-item-right">{{item.address | blankFormat}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
            </div>
            <home-foot></home-foot>
        </div>
    </div>
</template>


<script>
import HomeFoot from "@/components/HomeFoot"
import videoCommon from "@/components/videoCommon";
import Bus from '../Bus.js';
// import * as Animationjs from "@/assets/js/serviceSVG.js";
import mdPreview from "@/components/mdPreview";
export default {
    name: "service",
    data(){
        return{
            isShowAgentList:true,
            ServiceSupportData:{},//服务支持
            companyProfileData:{},
            imageClick:false,
        }
    },
    components:{
        HomeFoot,
        videoCommon,
        mdPreview,
    },
    filters: {
        blankFormat(val) {
            var html = ''
            if (val===undefined||val === null || val === '') {
                html = '-'
            } else {
                html = val
            }
            return html
        }
    },
    created(){
        //通过系统参数判断了解更多按钮和和各地营销中心是否显示
        if(sessionStorage.getItem("isShowAgentList")=='false'){
            this.isShowAgentList= false
        }else{
            this.isShowAgentList = true
        }
        this.$picData.map((item) => {
            if (item.dictCode == 104) {
                this.ServiceSupportData = item
            }else if(item.dictCode == 110){
                this.companyProfileData = item

            }
        })
        setTimeout(function(){
            this.window_height=$(".first-page").height();
        },1000)
        this.isEn = ('1' ==sessionStorage.getItem("isEn")? sessionStorage.getItem("isEn") : '0')
    },
    mounted(){
        let _this = this;
        this.InformationList = JSON.parse(JSON.stringify(this.Information));
        this.currentlist = this.InformationList.slice((this.currentPage-1)*20,this.currentPage*20);
        // this.window_height = $(".first-page").height();
        // Bus.$on('change_window_height',this.change_window_height)
        //  获取路由传参 ， 切换custormAnchor_nav
        let get_custormAnchor_nav = this.$route.params.custormAnchor_nav;
        if(get_custormAnchor_nav){
            this.custormAnchor_nav = this.$route.params.custormAnchor_nav;
        }
        Bus.$on('change_service_miao',function(p){
            _this.custormAnchor_nav = p;
            $('.service-page').animate({ scrollTop:(_this.window_height-100) }, 600);
        })
        var videoid =  document.getElementById('aboutvideo');
        if(videoid){
            var windowWidth = $(window).width();
            if(windowWidth < 991){
                videoid.autoplay=false;
            }else if(windowWidth >= 991){
                videoid.autoplay=true;
            }
        }
        this.videoAll = this.ServiceSupportData.children.filter(t=> t.title=="观看全部视频");
        this.getCenterData()
        axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/company/info?isEn=`+this.isEn,).then(response => {
            var res=response.data
            if(res.code=== 200){
                this.CompanyData = res.data
            }else{
                this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
            }
        }).catch(error=>{
            this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
        })
      //获取常见问题
      this.getCommonProblem();

    },

    data() {
        return {
            phoneNum:"400-888-7816",
            custormAnchor_nav:"miao1",//标签选择
            window_height:900,
            scroll_Value: "0",
            activeNames: ['a1'],
            SearchInformation:"",
            Information:[             // 原始数据
                {label:"T10&D8 SDK.zip",path:"/static/link/dataDownload/T10&D8 SDK.zip"},
                {label:"T6&D6&Z90&Z9 SDK.zip",path:"/static/link/dataDownload/T6&D6&Z90&Z9 SDK.zip"},
                {label:"t80安装手册.pdf",path:"/static/link/dataDownload/t80安装手册.pdf"},
                {label:"W-I SDK.zip",path:"/static/link/dataDownload/W-I SDK.zip"},
                {label:"RD600 SDK.zip",path:"/static/link/dataDownload/RD600 SDK.zip"},
                {label:"D3 SDK.zip",path:"/static/link/dataDownload/D3 SDK.zip"},
                {label:"p18智能车载pos安装手册.pdf",path:"/static/link/dataDownload/p18智能车载pos安装手册.pdf"},
                {label:"PCSC Reader SDK.rar",path:"/static/link/dataDownload/PCSC Reader SDK.rar"},
                {label:"T6&D6&Z9&Z90读卡器检测工具.zip",path:"/static/link/dataDownload/T6&D6&Z9&Z90读卡器检测工具.zip"},
                {label:"T6-ULC SDK.rar",path:"/static/link/dataDownload/T6-ULC SDK.rar"},
                {label:"RD800 SDK.zip",path:"/static/link/dataDownload/RD800 SDK.zip"},
                {label:"T10SDK1.0.pkg",path:"/static/link/dataDownload/T10SDK1.0.pkg"},
            ],
            InformationList:[],//搜索组
            currentlist:[],//分页组
            jumpPage:"",  //跳页module
            currentPage: 1,  // 当前页
            pagination_show:true,
            click_changepage:false,
            window_width:document.body.clientWidth<991?true:false,
            MarketCenterInfoList_data:[],
            videoAll:"",
            CompanyData:{
                companyInfo:{
                    hotline:""
                },
                companyParamList:{}
            },
            commonProblemList:[],
            isEn:'0',
      }
    },
    methods:{
        // 分页器事件
        gopage(gopage){
            if(gopage<1||gopage>Math.ceil(this.InformationList.length/20)){
                return
            }
            this.currentPage = gopage;
            this.currentlist = this.InformationList.slice((this.currentPage-1)*20,this.currentPage*20);
        },
        bingsrcoll(e) {
            this.scroll_Value = e.srcElement.scrollTop;
        },
        custormAnchor(v){
            this.custormAnchor_nav = v;
        },
        openVideoShow(){
            this.$refs.videoProp.openVideoShow();
        },

        change_window_height(){
            this.window_height=$(".first-page").height();
        },
        getCenterData(){//获取各地营销中心数据
            axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/agent/list`).then(response => {
                console.log(response)
                var res=response.data
                if(res.code=== 200){
                    var records=res.data
                    this.MarketCenterInfoList_data=records
                }else{
                    this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
                }
            })
        },
        getCommonProblem(){
          axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/commonProblem?isEn=`+this.isEn).then(response => {
            console.log(response)
            let res=response.data
            if(res.code=== 200){
              this.commonProblemList=res.data;
            }else{
              this.$message.error(res.msg?res.msg:'请求有误，请稍后重试')
            }
          })
        }
    },
    watch:{
        SearchInformation(){
            // console.log(this.Information.length)
            this.InformationList = [];
            let Information = JSON.parse(JSON.stringify(this.Information));
            this.currentPage = 1;
            if(this.SearchInformation){
                let newlist = [];
                Information.forEach(item=>{
                    if(item.label.search(this.SearchInformation)!=-1){
                        this.InformationList.push(item);
                    }
                })
            }else{
                this.InformationList = Information;
            }
            this.currentlist = this.InformationList.slice((this.currentPage-1)*20,this.currentPage*20);
            // console.log(this.InformationList)
            // console.log(this.currentlist)
        },
        currentPage(){
            if(this.currentPage<1)this.currentPage=1;
            this.currentPage = this.currentPage.replace(/\D/g,'1');
            this.currentlist = this.InformationList.slice((this.currentPage-1)*20,this.currentPage*20);
        },

    },
    computed:{
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.service-page{
    // margin-top: 60px;
    overflow: auto;

}
.first-page {
    /* background: url("../assets/img/service_title.png") no-repeat; */
    /* background-size: 100% 100%; */
    background-size: 100% auto;
    position: relative;
    height:calc(100% - 60px);
}
#miao1{
    padding-right: 0px;
}
.first-page-titlepart{
    color: #fff;
    text-align: left;
    position: absolute;
    top: 40%;
    left: 15%;
    font-size: 64px;
}
.first-page-title{
    font-size: 48px;
    font-weight: 600;
}
.first-page-titlebottom{
    width:68px;
    border:1.5px solid #fff;
    margin:15px 0;
    border-radius: 5px;
    background: #fff;
}
.first-page-titledesc{
    font-size: 22px;
    color: #fff;
    font-weight: normal;
}

.about-menu {
  height: 60px;
  line-height: 60px;
  padding-left: 50px;
  border-bottom: 1px solid #E3E3E3;
}
.about-menu > div {
  display: inline-block;
    margin-right: 50px;
}
.about-menu > div > span {
    cursor: pointer;
    padding: 0;
    height: 100%;
    display: inline-block;
    color: #868686;
}


.about-content{
    // min-height:800px;
    font-size: 14px;
    color: #2C2C2C;
}
.about-content > div {
    min-width: 900px;
    /* max-width: 1600px; */
    margin: 0 auto;
    margin-top: 100px;
    margin-bottom: 100px;
    // min-height: 800px;
}
.about-content-title {
    /* font-size: 40px; */
    font-weight: 600;
    font-size: 32px;
    color: #2C2C2C;
}
.about-content-title .about-content-secondtitle {
  font-size: 21px;
  color: #a99595;
}

/* 常见问题折叠框 */
#miao2 .steps1{
    min-height: 500px;
}
.el-icon-remove-outline{
    position: absolute;
    right: 23px;
    background: #fff;
}
.el-icon-circle-plus-outline{
    position: absolute;
    right: 23px;
    background: #fff;
}

.el-collapse-item__arrow{
    border-bottom: 1px solid #ddd;
}
/* 折叠头 */
.quest-title{
    font-size: 18px;
    font-weight: 600;
}
/* 折叠体 */
.quest-describe{
    padding-top: 20px;
}




.Information-content{
    margin-top: 50px;
    height: 450px;
    overflow: hidden;
}
.Information-list{
    display: inline-block;
    height: 55px;
    line-height: 55px;
    border-bottom: 1px solid #E3E3E3;
    width: calc(50% - 40px);
    margin-right: 80px;
}
.Information-list:nth-child(2n+2){
    margin-right: 0;
}
.page-contont{
    /* float: right; */
    margin-top: 30px;
    width: 100%;
    text-align: right;
}
.page-contont>div{
    display: inline-block;
    margin-left: 10px;
}
.page-contont .el-icon-arrow-right,.el-icon-arrow-left{
    /* border: 1px solid #333; */
    color: #333;
    cursor: pointer;
}
.page-contont .cant-page{
    color: #ddd;
    /* border-color: #ddd; */
    cursor: not-allowed;
        padding: 3px;
    border: 1px solid #ddd;
}
.addPriceRowRightInput{
    padding: 3px 5px;
    width: 65px;
    display: inline-block;
    text-align: center;
}
#miao4{
    height: auto;
}
.miao4-title{
    font-weight: 600;
    font-size: 32px;
    color: #2C2C2C;
    width: 100%;
    line-height: 32px;
    margin-bottom: 74px;
}
.content-way{
    width: 100%;
}
.contact-way-rowdiv{
    font-size:14px;
    text-align: left;
    margin-top:20px;
    color: #696969;
}
.contact-title{
    font-size: 20px;
    color: #202020;
    font-weight: 600;
}
.contact-way-rowdiv div{
    margin-bottom: 5px;
}
.miao4-content-list{
    width:100%;
    margin: 100px 0 0;
}
.miao4-content-list-title{
    width: 100%;
    font-size: 24px;
    color: #2C2C2C;
    font-weight: 600;
    padding-bottom:18px;
    border-bottom: 1px solid #ECECEC;
}
.miao4-content-list-item{
    float: left;
    width: 32%;
    margin-top: 45px;
}
.miao4-content-list-item:nth-child(3n-1){
    margin:0 2%;
    margin-top: 45px;
}
.miao4-content-list-item-title{
    font-size: 20px;
    color: #202020;
    font-weight: 600;
    margin-bottom: 10px;
    word-break: break-all;
    text-align: justify;
}
.miao4-content-list-item-row {
    width: 100%;
    font-size: 14px;
    color: #696969;
    line-height: 24px;
}
.miao4-content-list-item-left{
    float: left;
}
.miao4-content-list-item-right{
    float: left;
    width: calc(100% - 50px);
    text-align: justify;
    word-break: break-all;
}
.change-p p{
    margin-bottom: 10px !important;
}
.downloadSpan{
    font-size: 14px;
    color: #3BBDE7;
    cursor: pointer;
}
.downloadSpan:hover{
    color: #22A6D1;
}
/* 移动端 */
.visible-sm-and-down{
    display: flex;
}
.mobile-change-p p{
    color: #2C2C2C;
    margin-bottom:0 !important;
    line-height:28px;
}
.mobile-content img{
    width:100%;
    margin-top:40px;
}


.hidden-sm-and-down {
    display: block !important
  }
  .visible-sm-and-down {
    display: none !important
  }
.middle2>div:nth-child(2){
  margin: 0 2%;
}

@media only screen and (max-width:991px) {
      .hidden-sm-and-down {
        display: none !important
    }
    .visible-sm-and-down {
        display: block !important
    }
    .contact-title{
        font-size: 18px;
    }
    .contact-way-rowdiv[data-v-90b5d9ea] {
        font-size: 14px;
        text-align: left;
        margin-top: 16px;
        color: #696969;
    }
    .contact-way-rowdiv div {
        margin-bottom: 2px;
    }
    .mobile-content img[data-v-90b5d9ea] {
        width: 100%;
        margin-top: 32px;
    }
    .miao4-content-list{
        width:100%;
        margin: 50px 0 0;
    }
    .miao4-content-list-title{
        width: 100%;
        font-size: 22px;
        color: #2C2C2C;
        font-weight: 600;
        padding: 0;
    padding-bottom: 10px;
        border-bottom: 1px solid #ECECEC;
    }
    .miao4-content-list-item{
        width: 100%;
        margin-top: 30px;
        min-height: auto;
    }
    .miao4-content-list-item:nth-child(3n-1){
        margin:0 ;
        margin-top: 30px;
    }
    .miao4-content-list-item-title{
        font-size: 18px;
        color: #202020;
        font-weight: 600;
        margin-bottom: 10px;
    }
    .miao4-content-list-item-row {
        width: 100%;
        font-size: 14px;
        color: #696969;
        line-height: 24px;
    }
    .miao4-content-list-item-left{
        float: left;
    }
    .miao4-content-list-item-right{
        float: left;
        width: calc(100% - 50px);
    }
}
.header-video{
    height: -webkit-fill-available;
    width: -webkit-fill-available;
    object-fit: cover;
}
.miao4-content-item-box{display: flex;flex-wrap: wrap;}
.afterService-content{
    margin-top: 20px;
    font-size: 14px;
    line-height: 30px;
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    word-wrap: break-word;
}

.applet-qrcode{
    width: 128px;
    margin: 0 auto;

    .applet-img{
        height: 128px;
        width: 128px;
        margin-bottom: 9px;
    }
    .applet-text{
        width: 128px;
        font-size: 14px;
        color: #868686;
        text-align: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/service.vue